import { useState, useEffect, useRef } from "react";
import {useHistory, Link} from "react-router-dom";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import CheckBox from '../../../shared/Fields/CheckBox';
import fullTextService from "../../../services/fulltextsearch";
import CloseIcon from '@material-ui/icons/Close';
import Button from "@material-ui/core/Button";
//import { read, utils, writeFile } from 'xlsx';
import { read, utils, writeFile } from 'sheetjs-style';
import _ from "lodash";
import { toast } from "react-toastify";
import SynonymEditor from "./SynonymEditor";

//Im sorry this is named ontologies


function SearchTerms(){

    const { t, i18n } = useTranslation("common");
    const history = useHistory();

    const userInfo = useSelector((state) => state.setUserInfo);
    
    const leftRef = useRef(null);

    const [dragging, setDragging] = useState(false);
    const [leftWidth, setLeftWidth] = useState(null)
    //const rightRef = useRef(null);

    const [searchTerms, setSearchTerms] = useState([]);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [activeTerm, setActiveTerm] = useState(null);

    const [doneLoading, setDoneLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Loading...")

    const toggle = useSelector(state => state.setToggle.toggle);

    const termAtom = {
        "id": "Unsaved Term",
        "taxonomy": "USER",
        "term": "New Term",
        "synonyms": [],
        "description": null,
        "parents": null,
        "supernodes": null,
        "userId": null,
        "userName": "",
        "isSelected": false
    };

    const [anySelected, setAnySelected] = useState(false);
    const [deleteAllPopup, setDeleteAllPopup] = useState(false);
    const [deleteSelectedPopup, setDeleteSelectedPopup] = useState(false);
    const [importPopup, setImportPopup] = useState(false);
    const [exportPopup, setExportPopup] = useState(false);
    
    const [uploadNotImportError, setUploadNotImportError] = useState(false);
    const [noExportNameError, setNoExportNameError] = useState(true);

    const [deleteAllSafetyCheck, setDeleteAllSafetyCheck] = useState(false);

    const [fileJson, setFileJson] = useState(null);
    const [fileName, setFileName] = useState(null);

    
    useEffect(async() => {

        if(userInfo !== undefined && userInfo !== null){
            document.title = "User created Ontologies";
            getUsersTerms();
        }

    },[userInfo]);

    async function getUsersTerms(){
        
        let searchParam = `&rows=${"50"}&json_query=${"*"}&ontologies=${"USER"}&user_id=${userInfo.current_user.gq_user_id}`;
        const searchRes = await fullTextService.getFullTextSearchTerm(
            history,
            searchParam
        );

        if(searchRes != undefined){
            if(searchRes.response_content){
                if(searchRes.response_content.results && searchRes.response_content.results.length > 0){

                    let terms = searchRes.response_content.results;

                    if(terms){
                        for(let i = 0; i<terms.length; i++){
                            terms[i].isSelected = false;
                        }

                        setSearchTerms(terms)
                        setDoneLoading(true);
                        return
                    }
                }
            }
        }
        //return above makes this else{}
        setLoadingMessage("Add New Terms")
        console.log("no results "+ JSON.stringify(searchRes.response_content))

    }

    function resizeTable(e){
        if(e.clientX > 0){
            let newWidth = e.clientX - leftRef.current.offsetLeft
            if(newWidth < 150){
                newWidth = 150;
            }
            if(newWidth > 500){
                newWidth = 500;
            }
            console.log(newWidth)
            setLeftWidth(newWidth)
        }
    }

    function selectTermForEdit(index){

       setActiveIndex(index)
       setActiveTerm(searchTerms[index]);
        
    }

    function createNew(){

        setActiveIndex(-1);
        let terms  = searchTerms;
        terms.unshift(termAtom);

        setSearchTerms([...terms]);
    }

    async function saveSearchTerm(){

        if(activeIndex !=-1){
            if(searchTerms[activeIndex].editedSynonyms !== undefined){
                let response = await SaveTermAtIndex(activeIndex)
            }
       
            setActiveIndex(-1);
            setActiveTerm(null);
        }else{
            toast.error("Cannot Save Empty List")
            return
        }
        cancelEdit();
    }


    async function SaveTermAtIndex(index){
        let userId = userInfo.current_user.gq_user_id;
        let wordRay = searchTerms[index].editedSynonyms;

        let synonymString = "";
        if(wordRay.length > 0 && userId !== null && userId !== undefined){
            
            wordRay = wordRay.filter((word) => word != "");

            for(let i=0; i<wordRay.length; i++){
                if(wordRay[i]!== ""){
                    synonymString+=wordRay[i];
                    if(i<wordRay.length-1){
                        synonymString+="\n";
                    }
                }
            }

            if(synonymString!==""){

                let postData={
                    user_id: userId,
                    word_list: synonymString
                }

                if(searchTerms[index].id !== "Unsaved Term"){
                    postData.term_id = searchTerms[index].id;
                }

                //synonymEditor.current.innerHTML = ""
                let response = await fullTextService.updateACSynonyms(postData, history);
                if(response.response_content!== undefined){
                    searchTerms[index] = response.response_content
                    setSearchTerms([...searchTerms]);
                }

            }
        }          
    }

    async function deleteTerms(all){

        let postData ={
            ids: []
        }
       
        let terms = searchTerms
        for(let i=0; i<terms.length; i++){
            if(all || terms[i].isSelected == true){
                terms[i].isSelected = false
                postData.ids.push(terms[i].id);
                terms.splice(i, 1);
                if(i == activeIndex){
                    setActiveIndex(-1);
                    setActiveTerm(null);
                }
                i=i-1;
            }
        }

        setAnySelected(false);
        setSearchTerms([...terms])
        await fullTextService.deleteSynonyms(postData, history);
    }

    function checkTerm(index){

        let terms = searchTerms;

        terms[index].isSelected = (!terms[index].isSelected);
        setAnySelected(ifTermsSelected());
        setSearchTerms([...terms]);
    }

    function ifTermsSelected(){
        if(Array.isArray(searchTerms)){
            for(let i = 0; i < searchTerms.length; i++){
                if(searchTerms[i].isSelected){
                    return true;
                }
            }
        }
        return false;
    } 
    
    function widthFunction(){
        if(leftWidth == null){
            return "fit-content"
        }else{
            return leftWidth+"px"
        }
    }

    function cancelEdit(){
        
        if(activeIndex!== -1){
            if(searchTerms[activeIndex].editedSynonyms !== undefined){
                searchTerms[activeIndex].editedSynonyms = undefined
                setSearchTerms([...searchTerms]);
                setActiveTerm({...searchTerms[activeIndex]});

            }
        }
    }
    
    function exportFile(){
        let jsonObj = [];

        for(let i = 0; i<searchTerms.length; i++){
            if(searchTerms[i].isSelected){
                let itemObj = {
                    "Search Terms": searchTerms[i].term
                }

                for( let k = 1; k< searchTerms[i].synonyms.length; k++){
                  
                    let key = "Synonym "+k;
                    itemObj[key] = searchTerms[i].synonyms[k];
                }
                jsonObj.push(itemObj);
            }
        }

        /* generate worksheet from state */
        const ws = utils.json_to_sheet(jsonObj);
        /* create workbook and append worksheet */
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Data");
        /* export to XLSX */
        writeFile(wb, fileName+".xlsx");
        setFileName(null)
    }

    const ImportFile = async() => {
        if (fileJson) {
            for(let i = 1; i < fileJson.length; i++){

                let newTerm = _.cloneDeep(termAtom);

                newTerm["term"] = fileJson[i][0];
                newTerm["editedSynonyms"] = fileJson[i];

                searchTerms.push(newTerm);
                await SaveTermAtIndex(searchTerms.length-1)
            }
            setSearchTerms([...searchTerms])
        }
    };


    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = utils.sheet_to_json(sheet, { header: 1 });

            if(Array.isArray(jsonData)){
                let headers = jsonData[0];
                if(Array.isArray(headers)){ //check header row to see if its an export

                    if(headers[0] !== "Search Terms"){
                        setUploadNotImportError(true)
                        setFileJson(null);
                        return
                    }

                    for(let i = 1; i<headers.length; i++){
                        let compareString = "Synonym "+i;
                        if(headers[i] !== compareString){
                            setUploadNotImportError(true)
                            setFileJson(null);
                            return
                        }
                    }
                }else{
                    setUploadNotImportError(true)
                    setFileJson(null);
                    return
                }

                for(let i = 1; i<jsonData.length;i++){
                    for(let k = 0; k < jsonData[i].length; k++){
                        let test = jsonData[i][k];
                        if(test == undefined){
                            setUploadNotImportError(true)
                            setFileJson(null);
                            return
                        }
                    }
                }

            }

            setUploadNotImportError(false)
            setFileJson([...jsonData]);
        };

        if(file != null){
            reader.readAsArrayBuffer(file);
        }else{
            setFileJson(null);
            return
        }
    };


    function handleFileName(value){
        if(value !=undefined && value !== null ){
            if (typeof value === 'string'){
                if(value !== "" && value.length >0){
                    setFileName(value)
                    setNoExportNameError(false)
                    return
                }
            }
        }
        setFileName(null)
        setNoExportNameError(true);
    }

    function goToFullText(){
        history.push('/fulltextsearch');

    }

    function setEditedSynonyms(wordRay){
        searchTerms[activeIndex].editedSynonyms = wordRay;

        setSearchTerms([...searchTerms])

    }

    return (
        <div className="fullWidthCenterAlign">
            <div className="CenterOntologies">
                <div className="ontologyBar">
                        <span className="HistoryTopper" onClick={()=>createNew()}>Create New Term</span>
                        <span className={anySelected === true? "HistoryTopper":"disabledHistory disableFixer"} onClick={()=>{setDeleteSelectedPopup(true)}}>Delete Selected</span>
                        <span className="HistoryTopper" onClick={()=>{setDeleteAllSafetyCheck(false);setDeleteAllPopup(true)}}>Delete All</span>
                        <span className={anySelected === true? "HistoryTopper":"disabledHistory disableFixer"} onClick={()=>{setExportPopup(true)}}>Export Selected</span>
                        <span className="HistoryTopper" onClick={()=>{setImportPopup(true)}}>Import</span>
                        <span className="HistoryTopper" onClick={()=>goToFullText()}>GQ Full Text</span>

                </div>
                <div>
                    <div className="ontologyTable">
                        <div style={{width: widthFunction()}}  className={`ontologyLeftFormat ${ toggle ? 'OntologyBoxBorder' : 'OntologyBoxBorderDark'}`} ref={leftRef}>
                            <div className={`borderGrey ${toggle ? 'leftTableInnerContainer' : 'leftTableInnerContainerDark'}`}>
                       
                            {searchTerms.map((value, index) => {
                            return (
                                <div className={`${toggle?"ontologyItem":"ontologyItemDark"} borderBlue"`} style={{height:"50px"}} key={index+"ont"}>
                                    <span style={{display: 'flex', paddingLeft: "3px", paddingRight: '2px' }}>
                                        <CheckBox checked={searchTerms[index].isSelected} style={{position:"absolute", marginRight: "-20px", backgroundColor: "white !important"}} onChange={()=>{checkTerm(index)}}></CheckBox>
                                    </span>
                                    <div className={index == activeIndex? "activeOntology": "notActiveOntology"} onClick={()=>{selectTermForEdit(index)}}>
                                        <div className="Ontologyformat">                                            
                                            {value.editedSynonyms === undefined &&
                                            <>
                                                <strong className={index == activeIndex? "appTextFont activeOntology": "appTextColor appTextFont notActiveOntology"}>{value.term}</strong>
                                                <span className={index == activeIndex? "appTextFont activeOntology": " appTextColor appTextFont notActiveOntology"}>ID: {value.id.replace("USER:", "")}</span>
                                            </>
                                            }
                                            {value.editedSynonyms !== undefined &&
                                            <>
                                                <strong className={index == activeIndex? "appTextFont activeOntology": "appTextColor appTextFont notActiveOntology"}>{value.editedSynonyms[0]}</strong>
                                                <span className={index == activeIndex? "appTextFont activeOntology": " appTextColor appTextFont notActiveOntology"}>ID: Not Saved</span>
                                            </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                        
                        {searchTerms.length == 0 && !doneLoading &&
                        <div
                         className="loadingContainer"
                        >
                           <span 
                            style={{padding: "10px"}}
                            className="appTextColor"
                           >
                            {loadingMessage}
                           </span>
                        </div>
                        }
                        </div>
                        </div>

                        <div className={dragging? "dragBoxDragging" :"dragBox"} onDrag={(e)=>{resizeTable(e)}}
                            onDragStart={()=>setDragging(true)} 
                            onDragEnd={()=>setDragging(false)}
                        >
                        </div>

                        <div className={toggle ? "OntologyBoxBorder": "OntologyBoxBorderDark"} style={{width: "100%"}} >
                            <div className={`borderBlue ${toggle? 'ontologyTextArea': 'ontologyTextAreaDark'}`}>
                                <SynonymEditor
                                    term = {activeTerm}
                                    setEditedSynonyms = {(wordRay)=>{setEditedSynonyms(wordRay)}}
                                    ontologySuggestions = {true}
                                >

                                </SynonymEditor>
                            </div>
                            <div className="ftOptionsButtons">
                                <div>
                                    <button className={activeIndex == -1 ? "submitButtonClassDisabled" : "submitButtonClass"} onClick={()=>{cancelEdit()}}>Undo Changes</button>
                                    <button className={activeIndex == -1 ? "ml-1 submitButtonClassDisabled" : "ml-1 submitButtonClass"} onClick={()=>saveSearchTerm()}>Save</button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            {deleteAllPopup &&
                <div>
                    <div className="popupBackdrop" onClick={()=>setDeleteAllPopup(false)}> 
                </div>
                <div className="fixedFullScreen">
                    <div className="OntologyPopup">
                        <div className="cancelX">
                            <Link href="#" className={"p-2 appTextColor"}><CloseIcon onClick={()=>setDeleteAllPopup(false)} /></Link>
                        </div>
                        <div className="ABSavejumbotron">
                            <br></br>
                            {toggle?
                                <span style={{marginLeft: "5%"}} className="center historyPopupHeader tableCaption">Delete <string>ALL</string> created search terms?</span>
                            :
                                <span style={{marginLeft: "5%", color:'white'}} className="center historyPopupHeader tableCaption">Delete <string>ALL</string> created search terms?</span>
                            }
                            <br></br>

                            <div style={{marginLeft: "18px", backgroundColor: !toggle? '#56545473': "white", width: "138px", height: "35px", display:"flex", alignItems: "center", borderRadius: "4px", padding: "2px"}}>
                                <CheckBox checked={deleteAllSafetyCheck} style={{position:"absolute", marginRight: "-20px", backgroundColor: "white !important"}} onChange={()=>{setDeleteAllSafetyCheck(!deleteAllSafetyCheck)}}></CheckBox>
                                <span>
                                    <span>Are you sure?</span>
                                </span>
                            </div>
                        
                            <div className="buttonBuffer" style={{marginRight: "5%", paddingTop: "15px"}}>
                                <Button className={"cancelButtonClass "} onClick={()=>setDeleteAllPopup(false)}>Cancel</Button>
                                <span className="ml-1"></span>
                                <Button className={!deleteAllSafetyCheck? "submitButtonClassDisabled": "submitButtonClass"} onClick={()=>{if(deleteAllSafetyCheck){deleteTerms(true); setDeleteAllPopup(false); setDeleteAllSafetyCheck(false)}}} disabled={!deleteAllSafetyCheck}>Delete</Button>
                            </div>
                        </div>
                    </div>
                </div>
             </div>		
            }
 
            {deleteSelectedPopup && 
            <div>
                <div className="popupBackdrop" onClick={()=>setDeleteSelectedPopup(false)}> 
                </div>
                <div className="fixedFullScreen">
                    <div className="OntologyPopup">
                        <div className="cancelX">
                            <Link href="#" className={"p-2 appTextColor"}><CloseIcon onClick={()=>setDeleteSelectedPopup(false)} /></Link>
                        </div>
                        <div className="ABSavejumbotron">
                            <br></br>
                                <span style={{marginLeft: "5%"}} className="center historyPopupHeader tableCaption">Delete <string>SELECTED</string> search terms?</span>
                            <br></br>
                        
                            <div className="buttonBuffer" style={{marginRight: "5%", paddingTop: "45px"}}>
                                <Button className={"cancelButtonClass "} onClick={()=>setDeleteSelectedPopup(false)}>Cancel</Button>
                                <span className="ml-1"></span>
                                <Button className={"submitButtonClass"} onClick={()=>{deleteTerms(false); setDeleteSelectedPopup(false)} }>Delete</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }  

        {importPopup && 
            <div>
                <div className="popupBackdrop" onClick={()=>setImportPopup(false)}> 
                </div>
                <div className="fixedFullScreen">
                    <div className="OntologyPopup">
                        <div className="cancelX">
                            <Link href="#" className={"p-2 appTextColor"}><CloseIcon onClick={()=>setImportPopup(false)} /></Link>
                        </div>
                        <div className="ABSavejumbotron">
                            <div className="importdiv">
                                <input
                                    type="file"
                                    accept=".xls,.xlsx"
                                    onChange={handleFileUpload}
                                />
                                {uploadNotImportError &&
                                <p className="importError">
                                    This file is not in GQ format
                                </p>
                                }
                            </div>
                        
                            <div className="buttonBuffer" style={{marginRight: "5%"}}>
                                <Button className={"cancelButtonClass "} onClick={()=>setImportPopup(false)}>Cancel</Button>
                                <span className="ml-1"></span>
                                <Button className={(uploadNotImportError || fileJson == undefined || fileJson == null)? "disableButtonClass":"submitButtonClass"} disabled={uploadNotImportError || fileJson == undefined || fileJson == null} onClick={()=>{ImportFile(); setImportPopup(false)} }>Import</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }  
            {exportPopup && 
            <div>
                <div className="popupBackdrop" onClick={()=>setExportPopup(false)}> 
                </div>
                <div className="fixedFullScreen">
                    <div className="OntologyPopup">
                        <div className="cancelX">
                            <Link href="#" className={"p-2 appTextColor"}><CloseIcon onClick={()=>setExportPopup(false)} /></Link>
                        </div>
                        <div className="ABSavejumbotron">
                            <div className="exportDiv">
                                <p className="historyPopupHeader" style={{marginLeft:"0px", marginBottom:"5px"}}>Please provide file name:</p>
                                <input
                                    placeholder={"Name"}
                                    style={toggle? {width: '100%'}: {width: '100%', backgroundColor: '#56545473', color: 'white'}}
                                    type="text"
                                    onChange={(e) => handleFileName(e.target.value)}
                                />
                                {noExportNameError &&
                                <p className="importError">
                                    Please provide Name
                                </p>
                                }
                            </div>
                        
                            <div className="buttonBuffer" style={{marginRight: "5%", paddingTop: "35px"}}>
                                <Button className={"cancelButtonClass "} onClick={()=>setExportPopup(false)}>Cancel</Button>
                                <span className="ml-1"></span>
                                <Button className={noExportNameError? "disableButtonClass":"submitButtonClass"} onClick={()=>{if(fileName!== "" && fileName !== null && fileName !== undefined){exportFile(); setExportPopup(false)}}}>Export</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }  
        </div>
    </div>
    );
}

export default SearchTerms;
